<template>
    <section class="c-case-hero">
        <div
            class="c-case-hero--loaded"
        >
            <div class="c-case-hero__content">
                <div class="hero-content">
                    <div
                        v-if="heroData.title"
                        class="hero-content__title"
                    >
                        <h1 v-html="textReplacer(heroData.title, 'hero-title-primary')" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script >
    import { textReplacer } from '@/helpers/helpers';

    export default {
        name: 'CaseStudiesHero',

        /**
         *
         * @inheritDoc
         */
        props: {
            heroData: {
                type    : Object,
                required: true,
            },
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            textReplacer,
        },
    };

</script>

<style lang="scss" src="./hero.scss"/>
